import React, { useState } from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";
import {
  BooleanInput,
  StateSelect,
  SystemCodeSelect,
  PaymentTermSelect
} from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = {
  Active: true
};
function CustomerFilters({ filters, onFilter, onClose, onReset }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = { ...inputs };
    if (
      e.target.name.includes("RecIdRef") ||
      e.target.name.includes("PaymentTermsRecIdRef")
    ) {
      updates[e.target.name] = parseInt(value);
    } else {
      updates[e.target.name] = value;
    }
    setInputs({ ...updates });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () =>
    onReset ? onReset() : onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded>
          <Label>Customer #</Label>
          <Input
            autocomplete="new"
            name="CustomerNo_contains"
            type="text"
            value={inputs.CustomerNo_contains}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <SystemCodeSelect
            icon="globe"
            label="Customer Type"
            lookup={{ Category: "Customer", Code: "CustomerType" }}
            name="CustomerTypeRecIdRef"
            value={inputs.CustomerTypeRecIdRef}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>Customer Name</Label>
          <Input
            autocomplete="new"
            name="Name_contains"
            type="text"
            value={inputs.Name_contains}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Bill To</Label>
          <BooleanInput
            name="BillToCust"
            value={inputs.BillToCust}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Order</Label>
          <BooleanInput
            name="OrderCust"
            value={inputs.OrderCust}
            onChange={handleChange}
          />
        </Control>
      </Field>

      <Field kind="group">
        <Control expanded>
          <Label>City</Label>
          <Input
            autocomplete="new"
            name="City_contains"
            type="text"
            value={inputs.City_contains}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>State</Label>
          <StateSelect
            name="State"
            value={inputs.State}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <PaymentTermSelect
            label="Payment Term"
            name="PaymentTermsRecIdRef"
            value={inputs?.PaymentTermsRecIdRef}
            where={{ Active: true }}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={handleChange}
          />
        </Control>
      </Field>

      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
CustomerFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func
};
CustomerFilters.defaultProps = {
  filters: {}
};
export default CustomerFilters;
